/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElOverlayModule } from '../cdk/overlay/overlay.module';
import { ElPopoverDirective } from './popover.directive';
import { ElPopoverComponent } from './popover.component';


@NgModule({
  imports: [ElOverlayModule],
  declarations: [ElPopoverDirective, ElPopoverComponent],
  exports: [ElPopoverDirective],
  entryComponents: [ElPopoverComponent],
})
export class ElPopoverModule {
}
